import {
  EyeOutlined,
  MinusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Upload,
} from "antd";
import React, { FC, useEffect, useState } from "react";
import dayjs from "dayjs";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import ConfirmModals from "../../../../utils/confirmModals";
import { errorMessage } from "../../../../utils/notificationUtils";

interface EnhancementProcedureAyushmanProps {
  enhancementProcedure: any;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  patientDetails: IFetchAllDetails | null;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  handleSubmitEnhancementProcedure: CallableFunction;
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  handleOk: CallableFunction;
  handleCancel: () => void;
  form: any;
  enhancementReasonOptions: Array<{ label: string; value: string }>;
  handleFileChange?: any;
  documentTypes?: any;
  uploadResult?: any;
  handleOpen?: any;
  setUploadResult?: any;
}

const getProcedureQuantityAllowed = (procedure: any): number => {
  const value = Number(
    procedure?.quantityallowed ??
      procedure?.quantityAllowed ??
      procedure?.QuantityAllowed ??
      0,
  );
  return Number.isFinite(value) && value > 0 ? value : 0;
};

const EnhancementProcedureAyushman: FC<EnhancementProcedureAyushmanProps> = (
  props,
) => {
  const containerStyle =
    props?.enhancementProcedure?.length > 0
      ? {
          border: "1px solid #D9D9D9",
          borderRadius: "16px",
          padding: "10px 20px",
          marginBottom: "0.8rem",
          width: "100%",
          background: "#E5F3F3",
        }
      : {}; // Empty object when condition is false
  const [procedureForm] = Form.useForm();
  const [deletionData, setDeletionData] = useState({
    procedure: {},
    remove: null as ((index: number | number[]) => void) | null,
    nameToRemove: null as number | null,
  });
  const [totalProcedureAmount, setTotalProcedureAmount] = useState<any>();
  const items = Form.useWatch("items", props?.form);
  const proceduresOfEnhancement = Form.useWatch("items", procedureForm);
  const [selectedIndex, setSelectedIndex] = useState<any>(null);

  useEffect(() => {
    if (props?.enhancementProcedure && props.enhancementProcedure.length > 0) {
      procedureForm.setFieldsValue({
        items: props.enhancementProcedure,
      });
    }
  }, [props.enhancementProcedure, procedureForm]);

  useEffect(() => {
    const calculateTotal = (data: any[]) => {
      return data?.reduce((sum: number, procedure: any) => {
        const amount = procedure?.unspecifiedProcedureAmount || procedure?.specialityType?.toLowerCase()
                                    ?.includes("s")
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
    };

    let total = 0;

    if (Array.isArray(items) && items.length > 0) {
      total += calculateTotal(items);
    }

    if (
      Array.isArray(proceduresOfEnhancement) &&
      proceduresOfEnhancement.length > 0
    ) {
      total += calculateTotal(proceduresOfEnhancement);
    }

    setTotalProcedureAmount(total);
  }, [props?.form, items, proceduresOfEnhancement]);

  const attachDocumentToProcedure = (index: number) => {
    const items = props?.form.getFieldValue("items") || [];

    const updatedItems = items?.map((proc: any, idx: number) => {
      if (idx === index) {
        return {
          ...proc,
          documents: props?.uploadResult?.[0],
        };
      }
      return proc;
    });

    props?.form.setFieldsValue({ items: updatedItems });
  };

  useEffect(() => {
    if (props?.uploadResult?.[0] && (selectedIndex || selectedIndex === 0)) {
      attachDocumentToProcedure(selectedIndex);
    }
  }, [props?.uploadResult, selectedIndex]);

  const handleConfirm = async () => {
    await props?.handleOk(deletionData?.procedure);
    if (deletionData.remove && deletionData.nameToRemove !== null) {
      deletionData.remove(deletionData.nameToRemove);
    }
  };

  return (
    <div
      style={{ padding: "14px", height: "110vh", overflow: "auto" }}
      className="Deepak enhancement-procedures-modal"
    >
      {/* <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <Button
          style={{
            border: "1px solid darkcyan",
            background: "darkcyan",
            fontSize: "14px",
            fontWeight: "400",
            color: "white",
            height: "30px",
            marginTop: "1px",
          }}
          onClick={props?.handleFetchProcedureList}
        >
          Fetch Procedure List
        </Button>
      </div> */}

      <Form form={procedureForm} layout="vertical">
        <Form.List name="items">
          {(fields, { remove }) => (
            <div className="fetchedProcedureList" style={containerStyle}>
              {fields?.map(({ key, name, ...restField }, index) => {
                const currentItem =
                  procedureForm.getFieldValue(["items", index]) ||
                  props?.enhancementProcedure?.[index] ||
                  {};
                const isFromPreAuth = currentItem?.fromPreAuth === true;
                const createdAtValue = currentItem?.createdAt;

                return (
                <Row
                  key={key}
                  gutter={[16, 16]}
                  align="top"
                  style={{
                    border: "1px solid #C4C4C4",
                    padding: "10px 20px",
                    borderRadius: "16px",
                    marginBottom:
                      procedureForm.getFieldValue("items")?.length - 1 !== index
                        ? "0.8rem"
                        : 0,
                    background: "white",
                  }}
                >
                  <Col span={24}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 8,
                        gap: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      {isFromPreAuth ? (
                        <span
                          style={{
                            background: "#004C8F",
                            color: "#fff",
                            borderRadius: 12,
                            padding: "2px 10px",
                            fontSize: 12,
                            fontWeight: 600,
                          }}
                        >
                          PreAuth
                        </span>
                      ) : createdAtValue ? (
                        <span
                          style={{
                            fontSize: 12,
                            color: "#555",
                            fontWeight: 500,
                            letterSpacing: 0.2,
                          }}
                        >
                          ENHANCEMENT DATE:{" "}
                          {dayjs(createdAtValue).isValid()
                            ? dayjs(createdAtValue).format("DD-MM-YYYY HH:mm:ss")
                            : String(createdAtValue)}
                        </span>
                      ) : (
                        <span />
                      )}
                    </div>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      label="Procedure"
                      name={[name, "procedureName"]}
                      rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input disabled={true} style={{ color: "black" }} />
                    </Form.Item>
                  </Col>

                  <Col span={7}>
                    <Form.Item
                      {...restField}
                      label="ICHI Code"
                      name={[name, "externalProcedureCode"]}
                      // rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        style={{ borderRadius: "5px", color: "black" }}
                        placeholder="Enter ICHI Code"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>

                  {/* {props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                  "CAPF NEW" ? (
                    <Col span={7}></Col>
                  ) : (
                    <></>
                  )} */}

                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      label="QUANTITY/NO OF DAYS"
                      name={[name, "numberOfDays"]}
                      rules={[{ required: true, message: "Required" }]}
                    >
                      <Input
                        disabled={true}
                        placeholder="Enter QUANTITY/NO OF DAYS"
                        style={{ borderRadius: "5px", color: "black" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={1}>
                    <Button
                      type="text"
                      style={{ color: "red", padding: "0" }}
                      icon={<MinusCircleOutlined />}
                      // onClick={async () => {
                      //   try {
                      //     const res = await props?.handleDeleteProcedure(
                      //       props?.enhancementProcedure?.[index]?.caseTherapyId, props?.enhancementProcedure?.[index]?.internalProcedureCode
                      //     );
                      //     if(res) {
                      //       remove(name);
                      //     }
                      //   }
                      //   catch(err) {
                      //   }
                      // }}

                      // onClick={async () => {
                      //   props?.setIsModalOpen(true);
                      //   setDeletionData({
                      //     procedure:
                      //       props?.enhancementProcedure?.[index],
                      //         remove: remove,
                      //         nameToRemove: name
                      //   });
                      //   // remove(name);
                      // }}
                      onClick={async () => {
                        const currentProcedureList =
                          procedureForm.getFieldValue("items");
                        const procedureToDelete = {
                          ...currentProcedureList[index],
                        };

                        props?.setIsModalOpen(true);

                        setDeletionData({
                          procedure: procedureToDelete,
                          remove: remove,
                          nameToRemove: name,
                        });
                      }}
                    />
                  </Col>

                  {/* <Col span={8}>
                    <Form.Item
                      {...restField}
                      label="ACCREDITATION STATUS"
                      name={[name, "accreditationStatus"]}
                      rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        disabled={true}
                        style={{ borderRadius: "5px", color: "black" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={7}>
                    <Form.Item
                      {...restField}
                      label="TREATING DOCTOR"
                      name={[name, "treatingDoctor"]}
                      rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        disabled={true}
                        style={{ borderRadius: "5px", color: "black" }}
                      />
                    </Form.Item>
                  </Col> */}

                  {(() => {
                    // Show this input only if procedureName does NOT contain "unspecified"
                    const isUnspecified =
                      procedureForm
                        .getFieldValue(["items", index, "specialityType"])
                        ?.toLowerCase() === "s" ||
                      !!procedureForm.getFieldValue([
                        "items",
                        index,
                        "unspecifiedProcedureName",
                      ]) ||
                      !!procedureForm.getFieldValue([
                        "items",
                        index,
                        "unspecifiedProcedureAmount",
                      ]);

                    return !isUnspecified ? (
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          label="AMOUNT"
                          name={[name, "procedureAmount"]}
                          rules={[
                            { required: true, message: "Required" },
                            {
                              pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                              message:
                                "Only numeric values with upto 2 dec. places!",
                            },
                            {
                              validator: (_, value) =>
                                value && parseInt(value, 10) < 1
                                  ? Promise.reject("Please Enter Valid Amount!")
                                  : Promise.resolve(),
                            },
                          ]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Input
                            style={{
                              borderRadius: "5px",
                              color: "black",
                            }}
                            placeholder="Enter Amount"
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  })()}

                  {(() => {
                    const isUnspecified =
                      procedureForm
                        .getFieldValue(["items", index, "specialityType"])
                        ?.toLowerCase() === "s" ||
                      !!procedureForm.getFieldValue([
                        "items",
                        index,
                        "unspecifiedProcedureName",
                      ]) ||
                      !!procedureForm.getFieldValue([
                        "items",
                        index,
                        "unspecifiedProcedureAmount",
                      ]);

                    return isUnspecified ? (
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          label="PROCEDURE NAME"
                          name={[name, "unspecifiedProcedureName"]}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Input
                            style={{ borderRadius: "5px", color: "black" }}
                            placeholder="Enter Procedure Name"
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  })()}

                  {(() => {
                    const isUnspecified =
                      procedureForm
                        .getFieldValue(["items", index, "specialityType"])
                        ?.toLowerCase() === "s" ||
                      !!procedureForm.getFieldValue([
                        "items",
                        index,
                        "unspecifiedProcedureName",
                      ]) ||
                      !!procedureForm.getFieldValue([
                        "items",
                        index,
                        "unspecifiedProcedureAmount",
                      ]);

                    return isUnspecified ? (
                      <Col span={7}>
                        <Form.Item
                          {...restField}
                          label="PROCEDURE AMOUNT"
                          name={[name, "unspecifiedProcedureAmount"]}
                          rules={[{ required: true, message: "Required" }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Input
                            style={{ borderRadius: "5px", color: "black" }}
                            placeholder="Enter Procedure Amount"
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  })()}

                  {props?.enhancementProcedure?.[index]?.strats
                    ?.toLowerCase()
                    ?.includes("y") ? (
                    <Col span={7}>
                      <Form.Item
                        {...restField}
                        label="STRATS NAME"
                        name={[name, "stratsName"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Input
                          style={{ borderRadius: "5px", color: "black" }}
                          placeholder="Enter Strats Name"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  {props?.enhancementProcedure?.[index]?.strats
                    ?.toLowerCase()
                    ?.includes("y") ? (
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        label="STRATS OPTIONS"
                        name={[name, "stratOptionValue"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Input
                          style={{ borderRadius: "5px", color: "black" }}
                          placeholder="Enter Strats Option"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  <div style={{ width: "100%" }}>
                    <h4 style={{ display: "flex", justifyContent: "end" }}>
                      Amount: ₹{" "}
                      {(() => {
                        const item = props?.enhancementProcedure[index];

                        const isUnspecified =
                          item?.specialityType?.toLowerCase() === "s" ||
                          !!item?.unspecifiedProcedureName ||
                          !!item?.unspecifiedProcedureAmount;

                        return isUnspecified
                          ? parseFloat(item?.numberOfDays || 0) *
                              parseFloat(item?.unspecifiedProcedureAmount || 0)
                          : parseFloat(item?.numberOfDays || 0) *
                              parseFloat(item?.procedureAmount || 0);
                      })()}
                      /-
                    </h4>
                  </div>
                </Row>
                );
              })}
            </div>
          )}
        </Form.List>
      </Form>

      <div className="procedureList">
        <Form
          form={props?.form}
          // onFinish={handleSubmit}
          labelAlign="left"
          labelWrap
          labelCol={{
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 8 },
            lg: { span: 6 },
          }}
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 16 },
            lg: { span: 18 },
          }}
          style={{ width: "100%" }}
        >
          <Form.List name="items">
            {(fields, { add, remove }) => (
              <div
                style={{
                  border:
                    Array.isArray(fields) && fields?.length > 0
                      ? "1px solid #D9D9D9"
                      : "none",
                  borderRadius: "16px",
                  padding: "10px 20px",
                  marginBottom: "0.8rem",
                  width: "100%",
                }}
              >
                {Array.isArray(fields) &&
                  fields?.map((field, index) => {
                    return (
                      <Row
                        key={field.key}
                        gutter={[16, 16]}
                        align="top"
                        style={{
                          border: "1px solid #C4C4C4",
                          padding: "10px 20px",
                          borderRadius: "16px",
                          marginBottom: "0.8rem",
                        }}
                      >
                        {/* {props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "CGHS NEW" ? (
                          <Col span={8}>
                            <Form.Item
                              {...field}
                              label="PROCEDURE REFERRAL"
                              name={[field.name, "procedureReferral"]}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Select
                                showSearch
                                defaultValue={`Select a Procedure Referral`}
                                options={props?.formattedProcedureReferral}
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )} */}

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            label="Procedure"
                            name={[field.name, "procedureCode"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Procedure`}
                              options={props?.formattedProceduresOptions}
                              onChange={async (value, option: any) => {
                                const selectedProcedure = JSON.parse(value);
                                const externalProcedureCode =
                                  selectedProcedure?.externalProcedureCode ||
                                  selectedProcedure?.procedurecode ||
                                  selectedProcedure?.procedureCode ||
                                  "";
                                const quantityAllowed =
                                  getProcedureQuantityAllowed(selectedProcedure);
                                const amount =
                                  option?.extra ??
                                  selectedProcedure?.amount ??
                                  null;
                                const currentQty = props?.form.getFieldValue([
                                  "items",
                                  index,
                                  "numberOfDays",
                                ]);
                                const numberOfDays =
                                  quantityAllowed === 1
                                    ? 1
                                    : currentQty || 1;

                                props?.form.setFieldsValue({
                                  items: {
                                    [index]: {
                                      externalProcedureCode,
                                      procedureAmount: amount,
                                      quantityAllowed:
                                        quantityAllowed || null,
                                      numberOfDays,
                                      procedureTotalAmount:
                                        parseFloat(String(numberOfDays ?? 0)) *
                                        parseFloat(String(amount ?? 0)),
                                    },
                                  },
                                });

                                const isStratApplicable =
                                  selectedProcedure?.isstratificationapplicable ===
                                    "Y" ||
                                  selectedProcedure?.strats
                                    ?.toLowerCase()
                                    ?.includes("y");

                                if (value && isStratApplicable) {
                                  const stratsFormData = {
                                    procedureId:
                                      selectedProcedure?.procedurecode ||
                                      selectedProcedure?.procedureCode ||
                                      selectedProcedure?.id,
                                    procedureName:
                                      selectedProcedure?.procedurename ||
                                      selectedProcedure?.procedureName,
                                  };

                                  const res =
                                    await props?.handleGetProcedureStrats(
                                      stratsFormData,
                                    );
                                  props?.form.setFieldsValue({
                                    items: {
                                      [index]: {
                                        stratsName: res?.stratsName,
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item
                            {...field}
                            label="ICHI Code"
                            name={[field.name, "externalProcedureCode"]}
                            // rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Input
                              style={{ borderRadius: "5px" }}
                              placeholder="Enter ICHI Code"
                              disabled={true}
                            />
                          </Form.Item>
                        </Col>

                        {/* {props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "CAPF NEW" ? (
                          <Col span={7}></Col>
                        ) : (
                          <></>
                        )} */}

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            label="QUANTITY/NO OF DAYS"
                            name={[field.name, "numberOfDays"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Input
                              style={{ borderRadius: "5px" }}
                              placeholder="Enter QUANTITY/NO OF DAYS"
                              disabled={
                                Number(items?.[index]?.quantityAllowed || 0) ===
                                1
                              }
                              onChange={(e) => {
                                const numberOfDays = e.target.value.trim();
                                const qty = Number(numberOfDays);
                                const maxAllowed = Number(
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "quantityAllowed",
                                  ]) || 0,
                                );

                                if (
                                  numberOfDays &&
                                  (!Number.isFinite(qty) || qty < 1)
                                ) {
                                  message.error(
                                    "Please enter a valid quantity (minimum 1)",
                                  );
                                  return;
                                }
                                if (
                                  maxAllowed > 0 &&
                                  Number.isFinite(qty) &&
                                  qty > maxAllowed
                                ) {
                                  message.error(
                                    `Quantity cannot exceed maximum allowed (${maxAllowed})`,
                                  );
                                  props?.form.setFieldsValue({
                                    items: {
                                      [index]: {
                                        numberOfDays:
                                          maxAllowed === 1 ? 1 : undefined,
                                      },
                                    },
                                  });
                                  return;
                                }

                                let procedureCodeValue =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "procedureCode",
                                  ]);
                                let parsedProcedure: any = null;
                                try {
                                  parsedProcedure = procedureCodeValue
                                    ? JSON.parse(procedureCodeValue)
                                    : null;
                                } catch {
                                  parsedProcedure = null;
                                }
                                const amount = parsedProcedure?.specialityType
                                  ?.toLowerCase()
                                  ?.includes("s")
                                  ? props?.form.getFieldValue([
                                      "items",
                                      index,
                                      "unspecifiedProcedureAmount",
                                    ])
                                  : props?.form.getFieldValue([
                                      "items",
                                      index,
                                      "procedureAmount",
                                    ]);

                                if (numberOfDays && amount) {
                                  const procedureAmount =
                                    parseFloat(numberOfDays) *
                                    parseFloat(amount);
                                  props?.form.setFieldsValue({
                                    items: {
                                      [index]: {
                                        procedureTotalAmount:
                                          procedureAmount?.toString(),
                                      },
                                    },
                                  });
                                } else {
                                  props?.form.setFieldsValue({
                                    items: {
                                      [index]: {
                                        procedureTotalAmount: 0,
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={1}>
                          {fields.length > 0 && (
                            <Button
                              type="text"
                              style={{ color: "red", padding: "0" }}
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(field.name)}
                            />
                          )}
                        </Col>

                        {/* <Col span={8}>
                          <Form.Item
                            {...field}
                            label="ACCREDITATION STATUS"
                            name={[field.name, "accreditationStatus"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Accreditation Status`}
                              options={props?.formattedAccreditationOptions}
                              onChange={async (value) => {
                                const externalProcedureCode =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "externalProcedureCode",
                                  ]);
                                const formData = {
                                  procedureId: externalProcedureCode,
                                  ward: props?.patientDetails?.patientResponse
                                    ?.cardCategory,
                                  isNabl:
                                    props?.patientDetails?.casesResponse
                                      ?.nabhStatus ||
                                    props?.patientDetails?.casesResponse
                                      ?.nablStatus,
                                  // (value?.split("~")?.[1] === "NABL" || value?.split("~")?.[1] === "NABH")
                                  //   ? true
                                  //   : false,
                                };
                                // const getAmount =
                                //   await props?.handleGetProcedureAmount(
                                //     formData
                                //   );
                                // const amount =
                                //   getAmount?.nablPackageAmount ||
                                //   getAmount?.nabhPackageAmount;

                                // let getAmount;
                                // try {
                                //   getAmount =
                                //     await props?.handleGetProcedureAmount(
                                //       formData
                                //     );
                                // } catch (err) {
                                //   // const fallbackFormData = {
                                //   //   ...formData,
                                //   //   isNabl: false,
                                //   // };
                                //   // try {
                                //   //   getAmount =
                                //   //     await props?.handleGetProcedureAmount(
                                //   //       fallbackFormData
                                //   //     );
                                //   // } catch (fallbackErr: any) {
                                //   //   // errorMessage(fallbackErr?.response?.data);
                                //   //   return;
                                //   // }
                                //   return;
                                // }
                                // const amount = !formData?.isNabl
                                //   ? getAmount?.nonNabhPackageAmount :
                                //     getAmount?.nabhPackageAmount;

                                // props?.form.setFieldsValue({
                                //   items: {
                                //     [index]: {
                                //       procedureAmount: amount,
                                //     },
                                //   },
                                // });
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item
                            {...field}
                            label="TREATING DOCTOR"
                            name={[field.name, "treatingDoctor"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Treating Doctor`}
                              options={props?.formattedTreatingDoctorsOptions}
                            />
                          </Form.Item>
                        </Col> */}

                        {(() => {
                          const procedureCodeStr = props?.form.getFieldValue([
                            "items",
                            index,
                            "procedureCode",
                          ]);
                          if (!procedureCodeStr) return null;

                          const procedureCodeObj = JSON.parse(procedureCodeStr);

                          // Show this input only if procedureName does NOT contain "unspecified"
                          const isNotUnspecified =
                            !procedureCodeObj.specialityType
                              ?.toLowerCase()
                              ?.includes("s");

                          return isNotUnspecified ? (
                            <Col span={8}>
                              <Form.Item
                                {...field}
                                label="AMOUNT"
                                name={[field.name, "procedureAmount"]}
                                rules={[
                                  { required: true, message: "Required" },
                                  {
                                    pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                    message:
                                      "Only numeric values with up to 2 decimal places are allowed!",
                                  },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{ borderRadius: "5px" }}
                                  placeholder="Enter Amount"
                                  onChange={(e) => {
                                    const amount = e.target.value.trim();
                                    const numberOfDays =
                                      props?.form.getFieldValue([
                                        "items",
                                        index,
                                        "numberOfDays",
                                      ]);

                                    if (numberOfDays && amount) {
                                      const procedureAmount =
                                        parseFloat(numberOfDays) *
                                        parseFloat(amount);
                                      props?.form.setFieldsValue({
                                        items: {
                                          [index]: {
                                            procedureTotalAmount:
                                              procedureAmount?.toString(),
                                          },
                                        },
                                      });
                                    } else {
                                      props?.form.setFieldsValue({
                                        items: {
                                          [index]: {
                                            procedureTotalAmount: 0,
                                          },
                                        },
                                      });
                                    }
                                  }}
                                  disabled={true}
                                />
                              </Form.Item>
                            </Col>
                          ) : null;
                        })()}

                        {(() => {
                          const procedureCodeStr = props?.form.getFieldValue([
                            "items",
                            index,
                            "procedureCode",
                          ]);
                          if (!procedureCodeStr) return null;

                          const procedureCodeObj = JSON.parse(procedureCodeStr);

                          // Show this input only if procedureName does NOT contain "unspecified"
                          const isUnspecified = procedureCodeObj.specialityType
                            ?.toLowerCase()
                            ?.includes("s");

                          return isUnspecified ? (
                            <Col span={8}>
                              <Form.Item
                                {...field}
                                label="PROCEDURE NAME"
                                name={[field.name, "unspecifiedProcedureName"]}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{ borderRadius: "5px" }}
                                  placeholder="Enter Procedure Name"
                                />
                              </Form.Item>
                            </Col>
                          ) : null;
                        })()}

                        {(() => {
                          const procedureCodeStr = props?.form.getFieldValue([
                            "items",
                            index,
                            "procedureCode",
                          ]);
                          if (!procedureCodeStr) return null;

                          const procedureCodeObj = JSON.parse(procedureCodeStr);

                          // Show this input only if procedureName does NOT contain "unspecified"
                          const isUnspecified = procedureCodeObj.specialityType
                            ?.toLowerCase()
                            ?.includes("s");

                          return isUnspecified ? (
                            <Col span={7}>
                              <Form.Item
                                {...field}
                                label="PROCEDURE AMOUNT"
                                name={[
                                  field.name,
                                  "unspecifiedProcedureAmount",
                                ]}
                                rules={[
                                  { required: true, message: "Required" },
                                  {
                                    pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                                    message:
                                      "Only numeric values with up to 2 decimal places are allowed!",
                                  },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{ borderRadius: "5px" }}
                                  placeholder="Enter Procedure Amount"
                                  onChange={(e) => {
                                    const amount = e.target.value.trim();
                                    const numberOfDays =
                                      props?.form.getFieldValue([
                                        "items",
                                        index,
                                        "numberOfDays",
                                      ]);

                                    if (numberOfDays && amount) {
                                      const procedureAmount =
                                        parseFloat(numberOfDays) *
                                        parseFloat(amount);
                                      props?.form.setFieldsValue({
                                        items: {
                                          [index]: {
                                            procedureTotalAmount:
                                              procedureAmount?.toString(),
                                          },
                                        },
                                      });
                                    } else {
                                      props?.form.setFieldsValue({
                                        items: {
                                          [index]: {
                                            procedureTotalAmount: 0,
                                          },
                                        },
                                      });
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          ) : null;
                        })()}

                        {props?.form.getFieldValue([
                          "items",
                          index,
                          "procedureCode",
                        ]) &&
                        JSON.parse(
                          props?.form.getFieldValue([
                            "items",
                            index,
                            "procedureCode",
                          ]),
                        )
                          ?.strats?.toLowerCase()
                          ?.includes("y") ? (
                          <Col span={7}>
                            <Form.Item
                              {...field}
                              label="STRATS NAME"
                              name={[field.name, "stratsName"]}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{ borderRadius: "5px" }}
                                placeholder="Enter Strats Name"
                                disabled={true}
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        {props?.form.getFieldValue([
                          "items",
                          index,
                          "procedureCode",
                        ]) &&
                        JSON.parse(
                          props?.form.getFieldValue([
                            "items",
                            index,
                            "procedureCode",
                          ]),
                        )
                          ?.strats?.toLowerCase()
                          ?.includes("y") ? (
                          <Col span={8}>
                            <Form.Item
                              {...field}
                              label="STRATS OPTIONS"
                              name={[field.name, "stratOptionValue"]}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Select
                                showSearch
                                defaultValue={`Select a Strats Value`}
                                options={
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "procedureCode",
                                  ]) &&
                                  (props?.procedureStrats[
                                    JSON.parse(
                                      props?.form.getFieldValue([
                                        "items",
                                        index,
                                        "procedureCode",
                                      ]),
                                    )?.id
                                  ]?.options?.map((option: any) => ({
                                    value: JSON.stringify(option),
                                    label: option?.stratOptionValue,
                                  })) ||
                                    [])
                                }
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            label="Enhancement Reason"
                            name={[field.name, "enhancementReason"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                            }}
                            rules={[
                              {
                                required: true,
                                message: "Select Enhancement Reason",
                              },
                            ]}
                          >
                            <Select
                              options={props?.enhancementReasonOptions}
                              placeholder="Select Enhancement Reason"
                              showSearch
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(4, 1fr)",
                              gap: 10,
                            }}
                          >
                            {props?.documentTypes
                              ?.filter(
                                (docType: any) =>
                                  docType?.label ===
                                  "justification for enhancement",
                              )
                              ?.map((docType: any) => {
                                const procedureDocuments =
                                  props?.form.getFieldValue(["items", index]) ||
                                  {};

                                const justificationDoc =
                                  procedureDocuments?.documents;

                                return (
                                  <div
                                    key={docType.id}
                                    style={{
                                      border: "1px solid #eee",
                                      padding: 10,
                                      borderRadius: 8,
                                      display: "flex",
                                      alignItems: "center",
                                      // gap: 8,
                                    }}
                                  >
                                    <Upload
                                      multiple={docType?.multiple}
                                      showUploadList={false}
                                      beforeUpload={() => false}
                                      // onChange={() => {
                                      //   setSelectedIndex(index);
                                      //   props?.handleFileChange &&
                                      //   props?.handleFileChange(
                                      //     docType?.labelId,
                                      //     docType?.multiple
                                      //   )
                                      // }
                                      // }
                                      onChange={
                                        props?.handleFileChange &&
                                        props?.handleFileChange(
                                          docType?.labelId,
                                          docType?.multiple,
                                        )
                                      }
                                    >
                                      <Button
                                        icon={<UploadOutlined />}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          borderRadius: 0,
                                          border: "none",
                                          borderTopLeftRadius: "6px",
                                          borderBottomLeftRadius: "6px",
                                        }}
                                        onClick={() => setSelectedIndex(index)}
                                        //   disabled={portalSubmission}
                                      ></Button>
                                    </Upload>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Button
                                        iconPosition="end"
                                        icon={
                                          justificationDoc ? (
                                            <EyeOutlined
                                              style={{ marginLeft: "0.6rem" }}
                                              onClick={() =>
                                                props?.handleOpen(
                                                  justificationDoc?.documentLabelType,
                                                  justificationDoc.documentUrl,
                                                )
                                              }
                                            />
                                          ) : null
                                        }
                                      >
                                        {docType.label}
                                        {(docType?.required || true) && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </Button>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </Col>

                        <div style={{ width: "100%" }}>
                          <h4
                            style={{ display: "flex", justifyContent: "end" }}
                          >
                            Amount: ₹{" "}
                            {props?.form.getFieldValue([
                              "items",
                              index,
                              "procedureTotalAmount",
                            ]) ?? 0}
                            /-
                          </h4>
                        </div>
                      </Row>
                    );
                  })}
                {
                  <Button
                    type="dashed"
                    // onClick={() => add()}
                    onClick={() => {
                      props?.setUploadResult([]);
                      add({
                        treatmentStartDate: props.patientDetails
                          ?.visitInfoResponse?.doa
                          ? dayjs(
                              props.patientDetails?.visitInfoResponse?.doa,
                              "DD-MM-YYYY HH:mm:ss",
                            )
                          : null,
                        numberOfDays: "1",
                        accreditationStatus:
                          // !props?.patientDetails?.casesResponse?.healthCareName
                          //   ?.toLowerCase()
                          //   ?.includes("saroj gupta")
                          //   ? "NABL~NABL"
                          //   : "NON NABL~NON NABL",
                          props?.patientDetails?.casesResponse?.nablStatus
                            ? "NABL~NABL"
                            : props?.patientDetails?.casesResponse?.nabhStatus
                              ? "NABH~NABH"
                              : "NON NABH~NON NABH",
                        // "NABH~NABH",
                        treatingDoctor: "OTHERS~OTHERS",
                        procedureReferral: "referral~REFERRAL",
                      });
                    }}
                    style={{
                      background: "#008B8B",
                      color: "white",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      border: "1px solid #C4C4C4",
                    }}
                  >
                    Add Procedure
                  </Button>
                }
              </div>
            )}
          </Form.List>
          <div style={{ width: "100%", marginBottom: "0.8rem" }}>
            <h4 style={{ display: "flex", justifyContent: "end" }}>
              Total Amount: ₹ {totalProcedureAmount}/-
            </h4>
          </div>

          {/* <Row justify="end" style={{ marginTop: "1rem" }}>
            <Form.Item wrapperCol={{ span: 16 }}>
              {
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    border: "1px solid darkcyan",
                    background: "darkcyan",
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "white",
                  }}
                >
                  SUBMIT
                </Button>
              }
            </Form.Item>
          </Row> */}
        </Form>

        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <Button
            style={{
              border: "1px solid darkcyan",
              background: "darkcyan",
              fontSize: "14px",
              fontWeight: "400",
              color: "white",
            }}
            onClick={() => {
              props?.onNext();
            }}
            // disabled={
            //   !areAllMandatoryFieldsFilled()
            // }
          >
            {"Save And Continue"}
          </Button>
        </div> */}
      </div>
      <ConfirmModals
        setIsModalOpen={props?.setIsModalOpen}
        isModalOpen={props?.isModalOpen}
        handleOk={handleConfirm}
        handleCancel={props?.handleCancel}
        text={"ARE YOU SURE YOU WANT TO DELETE THIS PROCEDURE"}
      />
    </div>
  );
};

export default EnhancementProcedureAyushman;
